const t=".gator-input-time-dropdown{position:absolute;width:max-content;max-width:90%;top:0;left:0;display:none;z-index:1}";export{t as default};
